import { Link, Outlet } from "react-router-dom";
import { LanguageSwitcher } from "../components/LanguageSwitcher.jsx";
import { useTranslation } from "../contexts/TranslationContext.jsx";
import { ScrollToTopButton } from "../components/ScrollToTopButton.jsx";

// Chrome público (marketing/auth): landing, login, registro, recuperação de senha.
// Header enxuto — sem links de app, sem menu de usuário.
export function PublicLayout() {
  const { t } = useTranslation();

  return (
    <div className="dark min-h-screen flex flex-col bg-[#0a0a0a] text-white">
      {/* Espaçador para compensar navbar fixa */}
      <div className="shrink-0 h-14" />

      <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-3 bg-[#0a0a0a]/80 backdrop-blur-xl border-b border-white/5">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="text-brand-500 font-bold text-xl tracking-tight">SecretDev</span>
        </Link>

        <div className="flex items-center gap-3 shrink-0">
          <LanguageSwitcher />
          <Link to="/login">
            <button className="px-4 py-2 rounded-lg border border-white/20 hover:border-white/40 text-gray-200 hover:bg-white/5 text-sm font-medium transition">
              {t("nav.login")}
            </button>
          </Link>
        </div>
      </nav>

      <Outlet />

      <ScrollToTopButton />
    </div>
  );
}
